import { api, unwrap } from './http';

export default {
  list: async (params = {}) => unwrap(api.get('/Notes', params)),

  getById: async (id) => unwrap(api.get(`/Notes/${id}`)),

  create: async (payload) => unwrap(api.post('/Notes', payload)),

  update: async (id, payload) => unwrap(api.put(`/Notes/${id}`, payload)),

  remove: async (id) => unwrap(api.delete(`/Notes/${id}`)),
};
